module.exports = __webpack_public_path__ + "img/Screenshot_config.2607a61b.png";